module.exports = __webpack_public_path__ + "01_very_short_yellow.713bdd1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/01_very_short_yellow.png
// module id = c1De
// module chunks = 0